const ENVIRONMENT_PRESETS = [
    { text: 'None', value: 'none' },
    { text: 'Modern Buildings', value: 'modern_buildings' },
    { text: 'Meadow 2', value: 'meadow_2' },
    { text: 'Snowy Hillside', value: 'snowy_hillside' },
    { text: 'Venice Sunset', value: 'venice_sunset_1k.hdr' },
    { text: 'Indoor', value: 'squash_court.hdr' },
    { text: 'Beach', value: 'beach' },
];

export { ENVIRONMENT_PRESETS };
